import { Plus } from 'lucide-react';

export function PlusIcon() {
  return (
    <div className="w-4 h-4 rounded-full bg-gray-dark-0 flex items-center justify-center shadow-sm">
      <Plus className="w-3 h-3 text-white" />
    </div>
  );
}
